import { Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogBoundryService } from "@secca/core/services/dialog-boundry.service";
import { DialogHelperUtilService } from "@secca/core/services/dialog-helper-util.service";
import { DialogMinimizableDirective } from "@secca/shared/directives/dialog-minimizable.directive";
import { DialogSelectableDirective } from "@secca/shared/directives/dialog-selectable.directive";
import { MinimizableDialogType } from "@secca/shared/enums/minimizable-dialog-type-enum";
import { AdditionalInfo, IAdditionalInfo } from "@secca/shared/interfaces/additional-info";
import { IFocusEnabled } from "@secca/shared/interfaces/focus-enabled";
import { IKeyboardEnabled } from "@secca/shared/interfaces/keyboard-enabled";
import { IMinimizable } from "@secca/shared/interfaces/minimizable";
import { MedicalAssessmentComponent } from "../medical-assessment.component";
import { MedicalAssessmentDialogData } from "./medical-assessment-data.component";

@Component({
    selector: 'app-medical-assessment-dialog',
    templateUrl: './medical-assessment-dialog.component.html',
    styleUrls: ['./medical-assessment-dialog.component.scss'],
    standalone: false
})
  export class MedicalAssessmentDialogComponent implements IAdditionalInfo, IMinimizable, IKeyboardEnabled, IFocusEnabled {
    @ViewChild(MedicalAssessmentComponent) wrappedInstance: MedicalAssessmentComponent;
    @ViewChild(DialogMinimizableDirective) minimizedDirective: DialogMinimizableDirective;
    @ViewChild(DialogSelectableDirective) selectableDirective: DialogSelectableDirective;

    data: MedicalAssessmentDialogData;

    constructor(private dialogRef: MatDialogRef<MedicalAssessmentDialogComponent>,
                @Inject(MAT_DIALOG_DATA) data: MedicalAssessmentDialogData,
                private dialogHelperUtilService: DialogHelperUtilService,
                public dialogBoundryService: DialogBoundryService) {
      this.data = data;
    }
    
    close() {
      this.dialogHelperUtilService.close(this.dialogRef, this.getAdditionalInfo()?.caseId);
    }

    keyboardClose(): void {
      this.wrappedInstance.close();
    }
    
    minimize() {
      this.minimizedDirective.minimize();
    }

    getMinimizeType(): MinimizableDialogType {
      return this.minimizedDirective.appDialogMinimizable;
    }

    getAdditionalInfo(): AdditionalInfo {      
      const caseId: number = +this.data.case.id;
      const caseNumber: string = this.data.case.caseNumber;

      return {
        caseId,
        hoverTitle: caseNumber || '',
        hoverText: ''
      };
    }
  
    getFocusElement(): any {
      return this.selectableDirective?.focusElement;
    }

    get MinimizableDialogType() {
      return MinimizableDialogType;
    }
}
